import { compose } from "./core";
import { background, border, color, flexbox, grid, layout, list, others, outline, position, shadow, space, transform, transition, typography } from "./config";
import { pseudoPropNames } from "./pseudo";
export var systemProps = compose(background, border, color, flexbox, layout, outline, grid, others, position, shadow, space, typography, transform, list, transition);
var layoutSystem = compose(space, layout, flexbox, grid, position);
export var layoutPropNames = layoutSystem.propNames;
export var propNames = [...(systemProps.propNames || []), ...pseudoPropNames];
//# sourceMappingURL=system.js.map